import { LOGIN_VERSION } from '../constants';
import { getConfig } from '../config';
import { storageUnify } from '../storage';

export function getUrl() {
  return new URL(location.href);
}
const getHost = (url: string) => new URL(url).host;
export function getFaviconUrl(url: string, size = 50): string {
  return `https://icon.horse/icon/${getHost(url)}/${size}`;
}

export const getStorageVersion = () => {
  const key = `${getConfig()?.appName}_${LOGIN_VERSION}`;
  // If there is an old version available, use the old one.
  if (!storageUnify.getItem(key)) {
    const loginVersion = storageUnify.getItem(LOGIN_VERSION);
    storageUnify.setItem(key, loginVersion || 'v2');
  }
  return key;
};
